import { Text } from '@mantine/core';

import { Trans } from 'react-i18next';

import type { FindOneVaultSearchResponseDTO } from '../../../../../shared/api/magellan/vaultSearch/dto';

type VaultSearchResultsHeaderProps = {
  searchData: FindOneVaultSearchResponseDTO;
};

export function VaultSearchResultsHeader({ searchData }: VaultSearchResultsHeaderProps) {
  return (
    <Text variant="sm" fw={400} c="gray.6">
      <Trans
        ns="bidResponse"
        i18nKey="search.results.header.subtitle"
        components={{
          highlight: (
            <Text span variant="sm" fw={500} c="primary.7">
              {searchData?.question}
            </Text>
          ),
        }}
      />
    </Text>
  );
}
